import AuthGuard from "@/middleware/auth";

export default [
  { path: "/packages/create", name: "PackagesCreate", component: () => import("@/views/packages/products/create"), beforeEach: AuthGuard },
  { path: "/packages/listing", name: "ManagePackages", component: () => import("@/views/packages/products/listing"), beforeEach: AuthGuard },
  {
    path: "/packages/railway-stations",
    name: "RailwayStations",
    component: () => import("@/views/packages/railway-stations"),
    beforeEach: AuthGuard
  },
  { path: "/packages/trains", name: "PackageTrains", component: () => import("@/views/packages/trains"), beforeEach: AuthGuard },
  { path: "/packages/hotels", name: "PackagesHotels", component: () => import("@/views/packages/hotels"), beforeEach: AuthGuard },
  { path: "/packages/sightseeing", name: "PackagesSightseeing", component: () => import("@/views/packages/sightseeing"), beforeEach: AuthGuard },
  { path: "/packages/visa-&-documents", name: "VisaDocuments", component: () => import("@/views/packages/visa-documents"), beforeEach: AuthGuard }
];
